import {
  dateFormat,
  localDataFormat,
} from '../../../../../shared/constants/apiDateFormat';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { isObject } from '../../../../../shared/utils/jsUtils';

/**
 * Formats date for display in auto-calculated input fields.
 * Returns placeholder '—' if date is invalid or has DatePicker error state (object with error).
 *
 * @param date - Date string in API format (YYYY-MM-DD) or null
 * @returns Formatted date (MMM DD YYYY) or '—' placeholder
 */
export const getRenderDate = (date: string | null) => {
  return date && !isObject(date)
    ? getFormattedDate(date, localDataFormat, dateFormat)
    : '—';
};
